import React from 'react'
import Shineyeffect from './Shineyeffect'
import { TypeAnimation } from 'react-type-animation';

function Hero() {
  return (
    <div className='mt-[100px] flex justify-center items-center flex-col overflow-x-hidden '>
        <div className=''>
        <p>
            <TypeAnimation
                    sequence={[
                            "Hello , We are ksy & kuinf ",1000 , 
                            "we are freelancer Work on",1000,
                        ]}
                        speed={50}
                        repeat={Infinity}
                        className='text-border2 mb-4 text-sm md:text-md text-white'
            />
        </p>
        </div>
        <div 
        data-aos="fade-right"
        data-aos-duration='2000'  
>
            <p class="text-border mb-4  text-4xl md:text-9xl uppercase font-bold ">thumbnails </p>
        </div>
        <div
        data-aos="fade-up"
        data-aos-duration='2000' 
        className=''>
            <p class="text-border3 mb-4 text-4xl md:text-8xl uppercase font-bold "> & Video editing</p>
        </div>
        <div 
        data-aos="fade-up"
        data-aos-duration='2000'
        className='flex justify-between items-center w-[650px] mt-12 flex-col space-y-7 md:flex-row md:space-y-0 group'>
            <a href="#Portfolio"><button className='text-white bg-[#C0392B] w-[200px] md:w-[300px] py-3  text-xl md:text-3xl rounded-lg font-light hover:text-[#C0392B]  hover:bg-white ease-in-out duration-300 '>Portfolio</button></a>            
            <a href="#Contact"><button className='text-[#C0392B] rounded-lg border border-white w-[200px] md:w-[300px]  text-xl py-3 md:text-3xl font-light hover:text-white hover:border-[#C0392B] ease-in-out duration-300'>Contact Us</button></a>
        </div>
    </div>
  )
}

export default Hero